/* blz-atc-full.js (23/10, audit non-preview T9) — Klaviyo „Added to Cart Full“ dùng chung cho:
 *  - áo "Thiết kế tay" (pmanual): manual-personalizer.liquid nạp file này; manual-personalizer.js gọi BlzAtcFull.fire("manual")
 *    khi dòng _type=manual được thêm THÀNH CÔNG;
 *  - SP non-custom thuần (pnc, custom.personalizer = none, không có personalizer): layout/theme.liquid nạp file này kèm data-blz-atc="pnc"
 *    -> tự nghe 'product-ajax:added' và bắn cho dòng KHÔNG cá nhân hoá.
 * Chỉ bắn SAU khi /cart/add thành công: Minimog product-form bắn 'product-ajax:added' (detail.product = dòng vừa thêm) khi response không lỗi;
 * add lỗi -> 'product-ajax:error', không bắn. Chặn trùng 1,5 s (chung cho mọi nơi gọi trên trang).
 * Payload GIỐNG fireAtcFull của r2-personalizer.js (identify cart_items/cart_count/cart_total + track items/item_count/total/$value;
 * mỗi item: title, variant, qty, price, name, preview, image, url) và THÊM year (Jahrgang) + type
 * (_type nếu có, vd 'manual'; có _preview -> 'preview'; có Name -> 'name'; còn lại 'none' = pnc / dòng thường).
 * Không có window.klaviyo (chưa consent cookie) -> bỏ qua êm. Tên khách = PII: không console.log.
 */
(function () {
  "use strict";
  var cs = document.currentScript;
  var wantPlain = !!(cs && cs.getAttribute("data-blz-atc") === "pnc");
  if (window.BlzAtcFull) { if (wantPlain) window.BlzAtcFull.watchPlain(); return; }   // nạp lại (Minimog chèn lại script) -> giữ bản cũ

  var lastTs = 0;
  function lineType(p) {
    if (p._type) return String(p._type);
    if (p._preview) return "preview";
    if (p.Name) return "name";
    return "none";
  }
  function fire(src) {
    try {
      if (Date.now() - lastTs < 1500) return;
      lastTs = Date.now();
      fetch("/cart.js", { credentials: "same-origin", headers: { accept: "application/json" } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var kl = window.klaviyo;
          if (!kl || typeof kl.push !== "function" || !cart || !cart.items) return;
          var items = cart.items.map(function (i) {
            var p = i.properties || {};
            return {
              title: i.product_title || "", variant: i.variant_title || "",
              qty: i.quantity || 1, price: (i.final_price || 0) / 100,
              name: p["Name"] || "", preview: p["_preview"] || "",
              image: i.image || "", url: i.url ? ("https://blazorastore.com" + i.url) : "",
              year: p["Jahrgang"] || "", type: lineType(p)
            };
          });
          var total = (cart.total_price || 0) / 100;
          var count = cart.item_count || items.length;
          // giống r2: ghi giỏ vào PROFILE trước (email đọc lúc GỬI -> luôn đủ giỏ mới nhất); event chỉ để TRIGGER flow
          kl.push(["identify", { cart_items: items, cart_count: count, cart_total: total }]);
          kl.push(["track", "Added to Cart Full", { items: items, item_count: count, total: total, $value: total }]);
        })
        .catch(function () { /* im lặng */ });
    } catch (e) { /* im lặng */ }
  }

  // dòng KHÔNG cá nhân hoá (pnc): không có Name / Jahrgang / Alter / _preview / _type / _tpl
  function isPlain(p) {
    p = p || {};
    return !p.Name && !p.Jahrgang && !p.Alter && !p._preview && !p._type && !p._tpl;
  }
  var plainOn = false;
  function watchPlain() {
    if (plainOn) return;
    plainOn = true;
    document.addEventListener("product-ajax:added", function (e) {
      try {
        var d = e && e.detail && e.detail.product;
        if (!d) return;
        var arr = (d.items && d.items.length) ? d.items : [d];
        for (var i = 0; i < arr.length; i++) {
          if (arr[i] && arr[i].id && isPlain(arr[i].properties)) { fire("pnc"); return; }
        }
      } catch (x) { /* im lặng */ }
    });
  }

  window.BlzAtcFull = { fire: fire, watchPlain: watchPlain };
  if (wantPlain) watchPlain();
})();
